module.exports = __webpack_public_path__ + "img/sticker-0-1.5fefd5a3.svg";